import { ISwiperOptions, TEffect } from '@/types';

export class SwiperOptions implements ISwiperOptions {
  public readonly sensitivity = 1;
  public readonly lock = false; // prevent swipe, use if you insert Swiper to another Swiper
  public readonly activeClass = 'active';
  public readonly autoHeight = false;
  public readonly delay = 3000;
  public readonly draggable = true;
  public readonly effect: TEffect = 'slide';
  public readonly fullWidth = true;
  public readonly hashNavigation = false;
  public readonly height = 0;
  public readonly loop = false;
  public readonly mobile = false;
  public readonly slideActiveClass = 'string';
  public readonly slideClass = 'string';
  public readonly slideVisibleClass = 'string';
  public readonly slidesPerView: 'auto' = 'auto';
  public readonly spaceBetween = 0;
  public readonly spaceBetweenSlides = 10;
  public readonly speed = 300;
  public readonly startIndex = 0;
  public readonly width = 0;
  public readonly wrapperClass = 'string';
  public readonly pagination = {
    clicked: true,
  };
  public readonly linkTo = '';
  public readonly navigation = {
    class: '',
    names: {
      next: '',
      prev: '',
    },
    /* tslint:disable */
    icon: `<svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 14L7.35858 7.64142C7.43668 7.56332 7.43668 7.43668 7.35858 7.35858L0.999999 1" stroke="white" stroke-width="1.4" stroke-linecap="round"/>
          </svg>`,
    /* tslint:enable */
    calibrateMargin: 20,
  };
  public readonly rtl = false;
}

